<template>
  <p>
    {{ question }}
    <slot></slot>
  </p>
  <div
    class="btn-group"
    :class="optionsWidth"
    role="group"
    :aria-label="name + 'option'"
    :style="{ pointerEvents: disabled ? 'none' : 'auto', opacity: disabled ? '0.65' : '1' }"
  >
    <radio-button
      v-for="(item, i) in options"
      :ref="name + i"
      v-bind:key="i"
      :name="name + 'GroupName'"
      :label="item"
      :value="selected"
      @change="onChange"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import RadioButton from "@/shared/components/RadioButton.vue";

export default defineComponent({
  name: "OptionsQuestion",
  emits: ["update:selected", "changed"],
  components: {
    RadioButton
  },
  model: {
    prop: "selected",
    event: "update"
  },
  props: {
    name: { type: String, required: true },
    question: { type: String, required: true },
    options: { type: Array<string>, required: true },
    selected: { type: String, required: true },
    width: { default: 100 },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    optionsWidth: function(): string {
      return `w-${this.width}`;
    }
  },
  methods: {
    onChange(newValue) {
      this.$emit("update:selected", newValue);
      this.$emit("changed", newValue);
    }
  }
});
</script>
